import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { MainService } from 'src/app/services/main/main.service';
import { SharedService } from 'src/app/services/shared/shared.service';

declare global {
  interface Window {
    google: any;
  }
}

@Component({
  selector: 'app-google-api',
  templateUrl: './google-api.component.html',
  styleUrls: ['./google-api.component.scss']
})
export class GoogleApiComponent implements OnInit {
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @Input() search_canada: any = 0;
  @Input() customClass: any = 'col';
  @ViewChild('zipCode') zipCode!: ElementRef<HTMLInputElement>;
  @ViewChild('zipCode1') zipCode1!: ElementRef<HTMLInputElement>;
  @Input() set model(value: any) {
    if (value) {
      this._model = value;
      setTimeout(() => {
        let element = this.t == 2 ? this.zipCode1?.nativeElement : this.zipCode?.nativeElement;
        if (element) {
          element.value = this._model;
        }
      });
    }
  }
  @Input() model1: any = '';
  @Input() defaultzip = {};
  @Input() t: any;
  @Input() label: any = 'Zip/Postal Code';
  @Input() label1: any = 'Address';
  @Input() isRequired: any = false;
  @Input() not_found = 'No Result Found';
  @Input() placeholder: any = 'Enter Zip';

  zipArray: any = [];

  options: any = {
    componentRestrictions: { country: ['CA', 'US', 'AS', 'GU'] },
    fields: ["address_components", "adr_address", "geometry", "name", "formatted_address"],
    types: ['(regions)']
  }
  optionsForUSTerritories = {
    componentRestrictions: { country: ['US', 'AS', 'GU', 'FA'] },
    fields: ["address_components", "adr_address", "geometry", "name", "formatted_address"],
    types: ['(regions)'],
  };

  optionsForCanada = {
    componentRestrictions: { country: ['CA'] },
    fields: ["address_components", "adr_address", "geometry", "name", "formatted_address"],
    types: ['(regions)'],
    strictBounds: true
  };

  zipObj: any;
  loaderService: any;
  scrollTimeOut: any
  registrationStep2: any
  notFindZipFromGoogle = false;
  optionType = this.optionsForUSTerritories;
  _model: any;
  constructor(public shareService: SharedService,
    public cd: ChangeDetectorRef, public mainService: MainService
  ) { }

  ngOnInit() {
    if (this.defaultzip && this.defaultzip['zip']) {
      this.zipObj = this.defaultzip;
      this.zipArray = [this.defaultzip];
    }
    document.getElementsByTagName('body')[0].onscroll = () => this.setposition();
    this.ScrollClasses()
  }

  ScrollClasses() {
    ['.mat-drawer-content', '.registrationStep2', '.transition', '.add_card_block', '.no_show_sidebar', '.hide_overflow', '.mat-dialog-content', '.make_payment'].forEach((item, index) => {
      if (item) {
        this.registrationStep2 = document.querySelector(item)
        this.registrationStep2 && this.registrationStep2.addEventListener('scroll', () => this.setposition());
      }
    })
  }

  setposition() {
    clearTimeout(this.scrollTimeOut)
    let className: any = document.querySelectorAll('.pac-container');
    if (!className) {
      return;
    }
    className = className[className.length - 1];
    let con: any
    if (this.t == 2) {
      con = document.querySelectorAll("#zip_code1");
    } else {
      con = document.querySelectorAll("#zip_code");

    }
    con = con && con[con.length - 1] && con[con.length - 1].getBoundingClientRect();
    const clientReact = con
    if (className && className['style'] && className['style']['top'] != `${clientReact && clientReact.top + 56}px`) {
      className['style']['top'] = Math.ceil(clientReact && clientReact.top + 56) + 'px';
    }
  }

  selectZip(event) {
    let inputElement: any
    if (this.t == 2) {
      inputElement = document.getElementById('zip_code1');
    } else {
      inputElement = document.getElementById('zip_code');
    }
    inputElement.blur();
    if (document.querySelector(".pac-item-selected")) {
      if (event && event.key == "Enter" && event.keyCode == 13) {
        const event1 = new KeyboardEvent('keydown', {
          key: 'Enter',
          code: 'Enter',
          keyCode: 13,
          which: 13,
          bubbles: true,
          cancelable: true
        } as KeyboardEventInit);
        if (this.t == 2) {
          document.querySelector("#zip_code1").dispatchEvent(event1)
        } else {
          document.querySelector("#zip_code").dispatchEvent(event1)
        }
      }
    } else {
      const event1 = new KeyboardEvent('keydown', {
        key: 'ArrowDown',
        code: 'ArrowDown',
        keyCode: 40,
        which: 40,
        bubbles: true,
        cancelable: true
      } as KeyboardEventInit);
      if (this.t == 2) {
        document.querySelector("#zip_code1").dispatchEvent(event1)
      } else {
        document.querySelector("#zip_code").dispatchEvent(event1)
      }
    }

  }


  handleAddressChange(item: any, search_canada?: any) {
    this.notFindZipFromGoogle = false;
    setTimeout(() => {
      if (this.t == 3) {
        this.getZipCode(this.zipObjectCovert(item, false))
      } else {
        this.setAddress.emit(this.zipObjectCovert(item, false))
      }
    }, 100);
    return
  }

  getZipCode(item: any) {
    const data = {
      addressObj: item
    }
    this.mainService.api(data, `add_address`, false)
      .subscribe(response => {
        if (!response.is_error) {
          if (response && response.data && response.data.city_id) {
            this.setAddress.emit(response.data);
          } else {
            this.setAddress.emit(response);
          }
        } else {
          console.log(response.override_text);
        }
      });
  }

  getZipCode2(item: any) {
    if (!this.notFindZipFromGoogle) {
      return;
    }
    this.mainService.api({ zipcode: item }, 'get_zipcode', false)
      .subscribe((response: any) => {
        if (!response.is_error) {
          this.notFindZipFromGoogle = false;
          this.setAddress.emit(this.zipObjectCovert(response.zip_info[0], true));
          // this.triggerTab();
          // setTimeout(() => {
          //   this.triggerTab();
          // }, 2000);
        } else {
          console.log(response.override_text);
        }
      });
  }

  zipObjectCovert(item?: any, isFrom?: any) {
    const desire_object: any = {};
    if (isFrom) {
      desire_object.city = item.city,
        desire_object.country_code = item.country_code,
        desire_object.city_id = item.city_id,
        desire_object.country_name = item.country_name,
        desire_object.state_code = item.state_code,
        desire_object.state_name = item.state_name,
        desire_object.zip = this._model || item.zipCode,
        console.log(desire_object, 'desire_object');
      this._model = this._model || item.zipCode;
      return desire_object;
    }
    let temp: any
    desire_object.place_id = item.place_id;
    desire_object.item = item;
    temp = item && item.address_components && item.address_components.find(inner => inner.types.includes('postal_code') || inner.types.includes('plus_code'));
    temp = temp && temp.long_name;
    desire_object.zip = temp;

    temp = item && item.address_components && item.address_components.find(inner => inner.types.includes('locality'));

    temp = temp || item && item.address_components && item.address_components.find(inner => inner.types.includes('administrative_area_level_2')) || item && item.address_components && item.address_components.find(inner => inner.types.includes('postal_town')) || item && item.address_components && item.address_components.find(inner => inner.types.includes('neighborhood')) || item && item.address_components && item.address_components.find(inner => inner.types.includes('administrative_area_level_3')) || item && item.address_components && item.address_components.find(inner => inner.types.includes('sublocality_level_1')) || item && item.address_components && item.address_components.find(inner => inner.types.includes('sublocality'));

    temp = temp && temp.long_name;
    desire_object.city = temp;

    temp = item && item.address_components && (item.address_components.find(inner => inner.types.includes('administrative_area_level_1')) || item.address_components.find(inner => inner.types.includes('country')));
    desire_object.state_name = temp && temp.long_name;
    desire_object.state_code = temp && temp.short_name;


    temp = item && item.address_components && item.address_components.find(inner => inner.types.includes('country'));
    desire_object.country_name = temp && temp.long_name;
    desire_object.country_code = temp && temp.short_name;

    if (item.geometry && item.geometry.location) {
      desire_object.latitude = item.geometry.location.lat();
      desire_object.longitude = item.geometry.location.lng();
    }

    this._model = this._model || desire_object.zip || item.zipCode;

    if (!desire_object.city && this.model) {
      this.notFindZipFromGoogle = true;
      this.getZipCode2(desire_object.zip);
    }
    return desire_object;
  }


  checkIfSelected(event) {
    if (!this.zipObj) {
      this.model = '';
    } else {
      if (this.zipObj.zip != this.model) {
        this.model = this.zipObj.zip;
      }
    }
    this.cd.detectChanges();
  }
  checkIfSelected1(event) {
    if (!this.zipObj) {
      this.model = '';
    } else {
      if (this.zipObj.zip != this.model) {
        this.model = this.zipObj.zip;
      }
    }
    this.cd.detectChanges();
  }

  omit_special_char(e) {
    let k;
    document.all ? k = e.keyCode : k = e.which;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  removeZipCode() {
    this.setAddress.emit('');
  }

  handelInput(event: any) {
    if (event.keyCode === 8) {
      this.model = '';
      this.setAddress.emit(this.zipObjectCovert('', true));
    }
  }

  findFromOurSystm(event: any) {
    setTimeout(() => {
      const parentElement: any = document.querySelectorAll('.pac-item');
      if (parentElement && parentElement.length) {
        return;
      }
      if ((!this._model || (this._model && this._model.length < 5 || this._model.length > 10))) {
        return;
      }
      this.notFindZipFromGoogle = true;
      this.getZipCode2(this._model);
    }, 1000);
  }

  detectZipFormat() {
    const input = this.model;
    const canadianPostalCodeRegex = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/;
    const usZipCodeRegex = /^\d{5}(-\d{4})?$/;
    if (canadianPostalCodeRegex.test(input)) {
      this.optionType = this.optionsForCanada;
    } else if (usZipCodeRegex.test(input)) {
      this.optionType = this.optionsForUSTerritories;
    } else {
      this.optionType = this.options;
      console.log('Input does not match either Canada or US ZIP code patterns.');
    }
  }


  triggerTab() {
    const event = new KeyboardEvent('keydown', {
      key: 'Tab',
      code: 'Tab',
      which: 9,
      bubbles: true,
      cancelable: true
    } as KeyboardEventInit);
    if (this.t === 2) {
      document.querySelector('#zip_code1').dispatchEvent(event);
    } else {
      document.querySelector('#zip_code').dispatchEvent(event);
    }
  }


  ngAfterViewInit() {
    setTimeout(() => {
      Array.from(document.querySelectorAll(this.t == 2 ? "#zip_code1" : "#zip_code")).map(item => item.setAttribute('autocomplete', 'off'))
      this.initializeAutocomplete();
    }, 1000);
  }

  initializeAutocomplete() {
    try {
      let userWindow: any = window.google;
      if (!userWindow) {
        console.error('Google Maps API is not loaded yet.');
        return;
      }

      const inputElement = document.getElementById(this.t == 2 ? 'zip_code1' : 'zip_code') as HTMLInputElement;

      if (inputElement) {
        if (userWindow && userWindow.maps) {
          const autocomplete = new userWindow.maps.places.Autocomplete(inputElement, {
            types: ['postal_code'], // Restrict to geocoding results
            componentRestrictions: { country: ['US', "CA"] } // Change as needed
          });

          autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();

            if (!place.geometry) {
              // User entered the name of a Place that was not suggested and
              // pressed the Enter key, or the Place Details request failed.
              window.alert("No details available for input: '" + place.name + "'");
              return;
            }

            this.extractAddressComponents(place);
          });

          console.log("Autocomplete initialized", autocomplete);
        }
      } else {
        console.error("Input element not found.");
      }
    } catch (error) {
      console.log(error)
    }
  }

  extractAddressComponents(place) {
    const addressComponents = place.address_components || []; // Handle potential null
    const addressDetails: any = {};

    for (const component of addressComponents) {
      const type = component.types[0];

      switch (type) {
        case 'street_number':
          addressDetails.streetNumber = component.short_name;
          break;
        case 'route':
          addressDetails.street = component.short_name;
          break;
        case 'locality':
          addressDetails.city = component.long_name;
          break;
        case 'administrative_area_level_1':
          addressDetails.state = component.short_name;
          addressDetails.state_code = component.short_name;
          addressDetails.state_name = component.long_name;
          break;
        case 'postal_code':
          addressDetails.zipCode = component.short_name;
          addressDetails.zip = component.short_name;
          break;
        case 'country':
          addressDetails.country_name = component.long_name;
          addressDetails.country = component.long_name;
          addressDetails.country_code = component.short_name;
          break;
        // Add more cases for other address components as needed
      }
    }

    // Add other details from place object
    if (place.formatted_address) {
      addressDetails.formatted_address = place.formatted_address;
    }
    if (place.adr_address) {
      addressDetails.adr_address = place.adr_address;
    }
    if (place.name) {
      addressDetails.name = place.name;
    }
    if (place.place_id) {
      addressDetails.place_id = place.place_id;
    }
    if (place.geometry && place.geometry.location) {
      addressDetails.latitude = place.geometry.location.lat();
      addressDetails.longitude = place.geometry.location.lng();
    }

      if ((!addressDetails.city || !addressDetails.state) && addressDetails.latitude && addressDetails.longitude) {
    const geocoder = new (window as any).google.maps.Geocoder();
    geocoder.geocode({ location: { lat: addressDetails.latitude, lng: addressDetails.longitude } }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const geoComponents = results[0].address_components;
        for (const comp of geoComponents) {
          const type = comp.types[0];
          if (type === 'locality' && !addressDetails.city) {
            addressDetails.city = comp.long_name;
          }
          if (type === 'administrative_area_level_1' && !addressDetails.state) {
            addressDetails.state = comp.short_name;
            addressDetails.state_code = comp.short_name;
            addressDetails.state_name = comp.long_name;
          }
        }
        this.handleAddressResult(addressDetails);
      }
    });
  } else {
    this.handleAddressResult(addressDetails);
  }

    // Display the extracted address details
    // this._model = addressDetails.zipCode;
    // Array.from(document.querySelectorAll('#zip_code')).map((item: any) => item.value = this._model);
    // console.log(addressDetails, 'addressDetails>>>>>>>>>>');
    // this.zipObjectCovert(addressDetails, true);
    // this.setAddress.emit(addressDetails);
    // setTimeout(() => {
    //   console.log(this._model)
    // }, 7000);
  }
  handleAddressResult(addressDetails: any) {
    this._model = addressDetails.zipCode;
    let selector = this.t == 2 ? '#zip_code1' : '#zip_code';
    Array.from(document.querySelectorAll<HTMLInputElement>(selector)).forEach(item => item.value = this._model);
    console.log(addressDetails, 'Final address details >>>');
    this.zipObjectCovert(addressDetails, true);
    this.setAddress.emit(addressDetails);
  }
}

